import type { QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { merchantQueryOptions } from "./merchant.query.options";
import { isVenueLive } from "./merchant.utils";

export async function redirectUnlessVenueLive({
  queryClient,
  slug,
}: {
  queryClient: QueryClient;
  slug: string;
}) {
  const venues = await queryClient
    .fetchQuery({ ...merchantQueryOptions(slug), staleTime: 0 })
    .catch(() => undefined);
  const venue = venues?.[0];
  if (venue && !isVenueLive(venue)) {
    throw redirect({ to: "/business/$slug", params: { slug }, replace: true });
  }
}
